export enum ViewType {
  DETAIL = "detail",
  LINKS_ONLY = "links_only"
}

export enum LocationTiers {
  CITY = "city",
  REGION = "provinces_state",
  COUNTRY = "country"
}
